(ns frontend.view.entity-viewers.modules.risk.sub
  (:require
   [common.schema.registry :as registry]
   [frontend.state.current-session :as session]
   [re-frame.core :as rf]))

(rf/reg-sub
 ::risks
 (fn [db [_ entity-id]]
   (get-in db [::risks entity-id])))

(rf/reg-sub
 ::load-started
 (fn [db [_ entity-id]]
   (get-in db [::load-started entity-id])))

(rf/reg-sub
 ::risks-loading?
 (fn [db [_ entity-id]]
   (get-in db [::risks-loading? entity-id])))

(rf/reg-sub
 ::all-risks-collapse-status
 (fn [db [_ entity-id]]
   (get-in db [::all-risks-collapse-status entity-id])))

(rf/reg-sub
 ::risks-collapse-statuses
 (fn [db [_ entity-id]]
   (get-in db [::risk-collapsed? entity-id])))

(rf/reg-sub
 ::risk-collapsed?
 (fn [db [_ entity-id risk-id]]
   (get-in db [::risk-collapsed? entity-id risk-id])))

(rf/reg-sub
 ::risk-popover-open?
 (fn [db [_ entity-id risk-id]]
   (get-in db [::risk-popover-open? entity-id risk-id])))

(def HARDCODED-COLUMNS
  [:risk/severity
   :risk/status
   :risk-holding/category
   :risk-holding/tags
   :risk/description
   :risk/mitigation
   :risk-holding/outcome
   ])

(rf/reg-sub
 ::risk-columns
 (fn [_db [_ entity-type]]
   (let [field-schema (registry/get-schema @session/tenant-schema entity-type)]
     (concat [:risk/severity
              :risk/status
              :risk-holding/category
              :risk-holding/tags
              :risk/description
              :risk/mitigation
              :risk-holding/outcome
              ]
             (->> field-schema
                  (map key)
                  (remove (fn [k]
                            (not (some #{(namespace k)} ["risk" "risk-holding"]))))
                  (remove (fn [k]
                            (some #{k} HARDCODED-COLUMNS)))
                  (remove (fn [k]
                            (= k :risk/title))))))))
